import { Component, Input } from '@angular/core';
import { InstantTableType } from 'src/app/models/rates-track.model';

@Component({
  selector: 'app-table-instant-rates',
  standalone: false,
  templateUrl: './table-instant-rates.component.html',
  styleUrl: './table-instant-rates.component.scss'
})
export class TableInstantRatesComponent {
  @Input() listOfData: any;

  generateIcon(courier: string) {
    if(courier === 'NINJA') return 'https://storage.googleapis.com/komerce/assets/illustration/NINJA.png';
    if (courier === 'JNE') return 'https://storage.googleapis.com/komship-bucket/shipment/jne-logo.png';
    if (courier === 'SICEPAT') return 'https://storage.googleapis.com/komship-bucket/shipment/sicepat-logo.png';
    if (courier === 'IDEXPRESS') return 'https://storage.googleapis.com/komship-bucket/shipment/idexpress-logo.png';
    if (courier === 'SAP') return 'https://storage.googleapis.com/komerce/rajaongkir/sapx-color.svg';
    if (courier === 'JNT') return 'https://storage.googleapis.com/komerce/assets/illustration/JNT.png';
    if (courier === 'GOSEND') return 'https://storage.googleapis.com/komerce/assets/illustration/gosend.svg';
    if (courier === 'LION') return 'https://storage.googleapis.com/komerce/assets/logo/lion-parcel.svg';
    if (courier === 'SPX') return 'https://storage.googleapis.com/komerce/assets/LP-Kompack/spx.svg';
    return ''
  }
}
